(() => {
	const observer = new MutationObserver(replacePrices);

	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});

	let timeout;
	function replacePrices() {
		clearTimeout(timeout);
		timeout = setTimeout(() => {
			const priceEls = document.querySelectorAll('.rebuy-money span:not([class]');
			priceEls.forEach((priceEl) => {
				if (!priceEl.innerText.includes('.00')) return;
				const isYMALSection = !!priceEl.closest('.rebuy-widget.widget-type-product');
				const isCompareAtPrice = !!priceEl.closest('.rebuy-money.compare-at');
				priceEl.innerText = priceEl.innerText.replace('.00', '');
				if (isCompareAtPrice) return;
				priceEl.innerText = isYMALSection
					? priceEl.innerText + ' ' + window.Shopify.currency.active
					: priceEl.innerText;
			});
		}, 10);
	}

	// const updateGiftWidgetBtn = (event) => {
	// 	const { items } = event.detail.cart.cart;
	// 	if (!items.length) return;
	// 	const removeGiftBtn = document.querySelector(
	// 		'.rebuy-cart__flyout-recommendations .rebuy-cart__flyout-item-remove--gift',
	// 	);
	// 	const giftWidgetContainer = document.querySelector('.rebuy-cart__flyout-recommendations');
	// 	const widgetId = window.cartThreshold.cartCrossSellWidgetId;
	// 	const giftItem = items.find((item) => item.properties._widget_id === widgetId);
	// 	const isGiftAdded = !!giftItem;
	// 	const isOnlyGiftLeft = isGiftAdded & (items.length === 1);

	// 	if (isGiftAdded) {
	// 		const giftItemKey = giftItem.key;
	// 		giftItem.final_price > 0 && window.newRemoveItem(giftItemKey);
	// 		removeGiftBtn?.addEventListener('click', () => window.newRemoveItem(giftItemKey));
	// 	}

	// 	removeGiftBtn && removeGiftBtn.classList.toggle('hidden', !isGiftAdded);
	// 	giftWidgetContainer && giftWidgetContainer.classList.toggle('gift-added', isGiftAdded);
	// 	isOnlyGiftLeft && removeGiftBtn.classList.add('hidden');
	// };

	class RebuyMultipleGWP extends HTMLElement {
			constructor() {
				super();
				this.rebuyWidgetId = window.cartThreshold.cartCrossSellWidgetId;
				this.firstRender = true;
				this.targetSelector = `#rebuy-widget-${this.rebuyWidgetId}`
			}

			connectedCallback(){
				this.widgetSetObserver();
			}

			disconnectedCallback(){
				this.observer.disconnect();
			}

			setVariables(){
				this.rebuyCart = this.closest("#rebuy-cart");
				this.openButtonContainer = this.querySelector("[data-multiple-gwp-open-container]")
				this.openButton = this.querySelector("[data-multiple-gwp-open-button]");
				this.closeButtons = this.rebuyCart?.querySelectorAll("[data-multiple-gwp-back-button]");
				this.closeArrow = this.rebuyCart?.querySelector("[data-multiple-gwp-back-arrow]")
				this.modal = this.querySelector("rebuy-multiple-gwp-modal");
				this.rebuyCloseButton = this.rebuyCart?.querySelector("[data-rebuy-cart-close-button]");

				this.addedProductEl = this.querySelector("[data-multiple-gwp-product]");
				this.removeGiftBtn = this.querySelector("[data-gwp-remove]");
				this.removeGiftBtnText = `Remove gift`;
				this.removeGiftBtnLoadingText = "Removing...";
			}
			setEvents(){
				this.openButton.addEventListener("click", this.onModalOpen.bind(this));
				this.closeButtons.forEach((button) => button.addEventListener("click", this.onModalClose.bind(this)));
				
				document.addEventListener('rebuy:cart.change', this.rebuyCartUpdate.bind(this));
				
				this.addEventListener("gwp-connect", this.gwpConnect.bind(this));
				this.addEventListener("gwp-disconnect", this.gwpDisconnect.bind(this));
			}

			rebuyCartUpdate(event){
				const { items } = event.detail.cart.cart;
				if (!items.length) return;
				
				const widgetId = window.cartThreshold.cartCrossSellWidgetId;
				const giftItem = items.find((item) => item.properties._widget_id === widgetId);
				this.isGiftAdded = !!giftItem;
				const isOnlyGiftLeft = this.isGiftAdded & (items.length === 1);
				if (this.isGiftAdded) {
					const giftItemKey = giftItem.variant_id;
					
					giftItem.final_price > 0  && window.newRemoveItem(giftItemKey);
					if (this._removeGiftHandler && this.removeGiftBtn) {
						this.removeGiftBtn.removeEventListener('click', this._removeGiftHandler);
					}
					this._removeGiftHandler = () => this.removeGiftBtnClick.call(this, giftItemKey);
					this.removeGiftBtn?.addEventListener('click', this._removeGiftHandler);
					this.setAddedGiftContent(giftItem);
				}

				
				this.addedProductEl.classList.toggle('hidden', !this.isGiftAdded);
				this.openButtonContainer.classList.toggle('hidden', this.isGiftAdded);
				isOnlyGiftLeft && this.addedProductEl.classList.add('hidden');
				this.modal.isRebuyWidgetVisible?.call(this.modal);
			}

			gwpConnect(){
				if(!this.isGiftAdded){
					this.openButtonContainer.classList.remove("hidden");
				}
				
			}

			gwpDisconnect(){
				this.openButtonContainer.classList.add("hidden");
			}

			setAddedGiftContent(giftItem){
				this.buttonLoadingReset();
				const {image, price, product_title, url, variant_title} = giftItem;
				const productImage = this.addedProductEl.querySelector("[data-gwp-image]");
				const productImageLink = this.addedProductEl.querySelector("[data-gwp-image-link]");
				const productTitle = this.addedProductEl.querySelector("[data-gwp-title]");
				const productOptions = this.addedProductEl.querySelector("[data-gwp-options]");
				const productPrice = this.addedProductEl.querySelector("[data-gwp-price]");

				productImage.src = image;
				productTitle.innerText = product_title;
				productTitle.setAttribute("href", url);
				productImageLink.setAttribute("href", url);
				productOptions.innerText = variant_title;
				productPrice.innerText = `( ${window.cartThreshold.currencySymbol}${price / 100} )`;
			}

			removeGiftBtnClick(giftItemKey){
				window.newRemoveItem(giftItemKey);
				this.setRemoveButtonLoading();
			}

			onModalOpen(){
				this.modal.classList.add("open");
				this.rebuyCloseButton.classList.add("hidden");
				this.closeArrow.classList.remove("hidden");
				this.modal.enableButtons.call(this.modal);
			}

			onModalClose(){
				this.modal.classList.remove("open");
				this.rebuyCloseButton.classList.remove("hidden");
				this.closeArrow.classList.add("hidden")
			}

			setRemoveButtonLoading(){
				this.removeGiftBtn.innerText = this.removeGiftBtnLoadingText;
				this.removeGiftBtn.setAttribute("disabled", true);
			}

			buttonLoadingReset(){
				this.removeGiftBtn.innerText = this.removeGiftBtnText;
				this.removeGiftBtn.removeAttribute("disabled");
			}

			widgetSetObserver(){
				this.observer = new MutationObserver((mutations, obs) => {
						this.isRebuyWidgetVisible()
				})
				
				this.observer.observe(this, {
						childList: true,
						subtree: true
				});
			}

			isRebuyWidgetVisible(){
				const targetElement = document.querySelector(this.targetSelector);
					if(targetElement){
						this.setVariables();
						this.setEvents();
						if(window.multipleRebuyEvent && this.firstRender){
							this.rebuyCartUpdate(window.multipleRebuyEvent);
							this.firstRender = false;
						}
					}
			}
	}

	class RebuyMultipleGWPModal extends HTMLElement {
			constructor(){
				super();
				this.rebuyWidgetId = window.cartThreshold.cartCrossSellWidgetId;
				this.targetSelector = `#rebuy-widget-${this.rebuyWidgetId}`

				this.buttonsDisablesBind = this.buttonsDisables.bind(this);
				this.onAddButtonClickBind = this.onAddButtonClick.bind(this);
				this.widgetSetObserver();
			}

			disconnectedCallback(){
				this.observer.disconnect();
			}

			setVariables(){
				this.mainRebuyGWPEl = this.closest("rebuy-cart-multiple-gwp");
				this.products = this.querySelectorAll(".rebuy-product-block");
				this.addProductButtons = this.querySelectorAll(".rebuy-product-block .rebuy-button");
			}

			setEvents(){
				document.addEventListener('rebuy.beforeAdd', this.buttonsDisablesBind);
				document.addEventListener('rebuy.add', this.onAddButtonClickBind);
			}

			removeEvents(){
				document.removeEventListener('rebuy.beforeAdd', this.buttonsDisablesBind);
				document.removeEventListener('rebuy.add', this.onAddButtonClickBind);
			}

			onAddButtonClick(){
				setTimeout(()=>{
					this.mainRebuyGWPEl.onModalClose.call(this.mainRebuyGWPEl);
				}, 100)
			}

			buttonsDisables(){
				this.addProductButtons.forEach((button) => button.classList.add("disabled"));
			}
			enableButtons(){
				this.addProductButtons.forEach((button) => button.classList.remove("disabled"));
			}
			
			widgetSetObserver(){
				this.observer = new MutationObserver((mutations, obs) => {
						this.isRebuyWidgetVisible()
				})
				
				this.observer.observe(this, {
						childList: true,
						subtree: true
				});
			}

			isRebuyWidgetVisible(){
				const targetElement = document.querySelector(this.targetSelector);
					const items = targetElement?.querySelectorAll(".rebuy-product-block");
					if(targetElement){
						this.setVariables();
						this.setEvents();
					}
					if (targetElement?.classList.contains("is-visible") && items.length) {
						const event = new CustomEvent("gwp-connect");
						this.mainRebuyGWPEl?.dispatchEvent(event);
					}
					if(targetElement?.classList.contains("is-hidden") || !items?.length){
						this.removeEvents();

						const event = new CustomEvent("gwp-disconnect");
						this.mainRebuyGWPEl?.dispatchEvent(event);
					}
			}
	}


	if (!customElements.get('rebuy-cart-multiple-gwp')) {
		customElements.define('rebuy-cart-multiple-gwp', RebuyMultipleGWP);

		if (!customElements.get('rebuy-multiple-gwp-modal')) {
			customElements.define('rebuy-multiple-gwp-modal', RebuyMultipleGWPModal);
		}
	}

	document.addEventListener('rebuy:cart.ready', (event) => {
			window.rebuyCartEvent = event;
			window.multipleRebuyEvent = event;
	});
	
})();
